import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import Product from './Product';
import toastr from 'toastr'
import GoBack from './GoBack';
import Progress from '../Progress'

function Step3() {
    const authContext = useContext(AuthContext);
    let { step, gotoNextStep, lp, lead, goBack } = authContext;
    let { products } = lp;
    const initialState = {
        type_id: lead.offer ? lead.offer.product_type_id : null,
        selected: lead.offer ? lead.offer.product_id : null,
    }
    const [fields, setFields] = useState(initialState);

    const setType = (type, product) => {
        setFields({
            selected: product,
            type_id: type,
        });
        setTimeout(() => {
            const target = type;
            const payload = {
                selected: product,
                type_id: type,
            }
            if (!target) {
                toastr.error('Please Select a Product');
            } else {
                gotoNextStep(payload, step);
            }
        }, 550);
    }
    const savingsAmount = () => {
        let $volume = lead.business_monthly_volume;
        let $value;
        if (lead.business_monthly_volume != '$100,000+') {
            let $arr = $volume.split('-');
            $value = parseInt($arr[1].replace('$', '').replace(',', ''));
        } else {
            $value = parseInt(lead.business_monthly_volume.replace('$', '').replace(',', '').replace('+', ''));
        }
        return ($value * 3.11 / 100).toFixed(0);
    }
    const $amount = savingsAmount();

    return (
        <>

            <form action="" method="POST">
                <div className="container text-center">
                    <h4 className="mb-5 qualify-title">You qualify for <span className="colored">0% Processing</span> with potential savings of up to <span className="colored">${$amount}</span> a month based on your monthly card volume!</h4>
                    <Progress step={step} />
                    <p className="mb-4 meth">Choose your processing method below and get started!</p>
                </div>

                <div className="container-fluid">

                    <div className="bottom-form mb-4">
                        <div className="grid_list" id="prodWrap">
                            {products.map((product) => {
                                return (<Product key={product.id} product={product} selected={fields.selected} type_id={fields.type_id} setType={setType} />)
                            })}
                        </div>
                        {/* {!fields.type_id ? <p className="text-muted mb-0 text-center pt-5"><small>please choose your payment option</small></p> : <SubmitForm />} */}
                    </div>

                </div>

            </form>
            <div className="bottom-buttons justify-content-center">
                <GoBack goBack={goBack} step={step} />
            </div>
        </>
    )
}

export default Step3
